import { Component, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { SizeWindow } from '../../../shared/enums/size-window';

@Component({
  selector: 'app-template-popup-visitor',
  templateUrl: './template-popup-visitor.component.html',
  styleUrls: ['./template-popup-visitor.component.scss']
})
export class TemplatePopupVisitorComponent implements OnInit {

  @Input() size: { outerWidth: number, innerHeight: number, sizeWindow: SizeWindow, sizeWindowNumber: number, sizeWindowText: string} = { outerWidth: 0, innerHeight: 0, sizeWindow: SizeWindow.XS, sizeWindowNumber: 0, sizeWindowText: ""};
  @Input() displaySocieteLogo?:boolean;
  @Input() width?:number;
  @Input() height?:number;
  @Input() heightPercent?:number;
  @Input() widthPercent?:number;
  @Input() maxWidth?:number;
  @Input() maxWidthPercent?:number;
  @Input() maxHeightPercent?:number;
  @Input() maxHeight?:number;
  @Input() overflow: string = 'none';

  @Input() Document_Logo_URL?:string;


  SizeWindow = SizeWindow;

  fileStoragePath: string = "";

  constructor(public dialogRef: MatDialogRef<TemplatePopupVisitorComponent>) {
    this.fileStoragePath = environment.fileStoragePath;
   }

  ngOnInit(): void {
    if(this.displaySocieteLogo == undefined){
      let receiveModeGestion = localStorage.getItem("ModeGestion");
      this.displaySocieteLogo = receiveModeGestion ? !JSON.parse(receiveModeGestion).activation : true;
    }
  }

}
